import { useLocales } from "@/locales";
import { CommonWrap, ComomonAlert } from "@/PageComponents/common";
import ContentWrap from "@/DocLayout/Content/Index";
import { Box } from "@mui/material";

export default function WebhookRetryLogic() {
  const { translate, currentLang } = useLocales();
  return (
    <ContentWrap
      showBorderBottom={false}
      leftChildrenSx={{
        paddingTop: "1px",
        paddingBottom: "32px",
      }}
      leftChildren={
        <CommonWrap>
          <>
            <Box id="retry-logic" component={"div"} className="title_0">
              {translate("webhook_use.retry_logic_title")}
            </Box>
            <Box component={"div"} className="desc">
              {translate("webhook_use.retry_logic_desc")}
            </Box>
            {currentLang.value === "en" && (
              <Box component={"div"} className="title_1">
                {translate("webhook_use.retry_logic_desc_title")}
              </Box>
            )}

            <Box
              sx={{
                ul: {
                  paddingLeft: "2em",
                },
                li: {
                  "::marker": {
                    textIndent: "em",
                  },
                },
              }}
            >
              <ul>
                {[...Array(6)].map((item, i) => (
                  <li key={i}>
                    <Box component={"div"} className="desc">
                      {translate(`webhook_use.retry_logic_list${i + 1}`)}
                    </Box>
                  </li>
                ))}
              </ul>
            </Box>
            <ComomonAlert severity="warning">
              {translate("webhook_use.retry_logic_tip_desc")}
            </ComomonAlert>
          </>
        </CommonWrap>
      }
    />
  );
}
